// extracted by mini-css-extract-plugin
export var sliderRange = "_cc-2";
export var sliderRoot = "_cc-0";
export var sliderThumb = "_cc-3";
export var sliderTrack = "_cc-1";